import { getDate, getMonth, getYear, startOfToday } from 'date-fns';

import { utcToZonedTime } from '@adsk/date-fns-tz';

export default (timeZone?: string) => {
  if (!timeZone) return startOfToday();

  const utcNow = new Date();
  const timeZonedDate = utcToZonedTime(utcNow, timeZone);
  return new Date(
    getYear(timeZonedDate),
    getMonth(timeZonedDate),
    getDate(timeZonedDate),
  );
};
